import { Typography } from "@fullscript/aviary-web";
import { Trans, useTranslation } from "react-i18next";

import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./ConnectCheckEmailCard.styles";

interface Props {
  email: string;
}

const ConnectCheckEmailCard = ({ email }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={styles.card}>
      <Typography as="h2" variant="h3" colorIntensity="bold" isMarginless>
        {t(l.signIn.checkYourEmail)}
      </Typography>
      <Typography isMarginless>
        <Trans
          i18nKey={l.connect.checkEmail.body}
          values={{ email }}
          shouldUnescape
          components={{
            emailText: <strong />,
          }}
        />
      </Typography>
      <Typography variant="footnote" colorIntensity="subtle" isMarginless>
        {t(l.connect.checkEmail.spamHint)}
      </Typography>
    </div>
  );
};

export { ConnectCheckEmailCard };
export type { Props as ConnectCheckEmailCardProps };
